import { unionBy } from 'lodash';

import { PRIVACY_TYPE } from '@/constants/common';
import * as types from '@/redux/actionTypes';
import mokaRequest from '@/tools/mokaRequest';
import { getI18n } from '@/utils/i18n';

const i18n = getI18n();

function updateOrg(org) {
  return {
    type: types.UPDATE_ORG,
    payload: { org },
  };
}

function updateOrgList(orgList) {
  return {
    type: types.UPDATE_ORG_LIST,
    payload: { orgList },
  };
}

function loadingIndicator(loading = true, type) {
  return {
    type,
    payload: loading,
  };
}

function updateHeadhunterSetting(setting) {
  return {
    type: types.UPDATE_HEADHUNTER_SETTING,
    payload: { setting },
  };
}

function updateHeadhunterApplyForm(applyForm) {
  return {
    type: types.UPDATE_HEADHUNTER_APPLY_FORM,
    payload: { applyForm },
  };
}

function updateOverseasNumber(overseasNumberSetting) {
  return {
    type: types.UPDATE_OVERSEAS_NUMBER_SETTING,
    payload: { overseasNumberSetting },
  };
}

export function fetchOrg(orgId) {
  return (dispatch) => {
    dispatch(loadingIndicator(true, types.LOAD_ORG));
    mokaRequest('/api/outer/ats-jc/headhunter/org/info', {
      query: { orgId },
      actionName: i18n.t`获取公司信息`,
      interceptOnError: true,
    })
      .get()
      .then((org) => {
        dispatch(updateOrg(org));
        dispatch(loadingIndicator(false, types.LOAD_ORG));
      })
      .catch(() => {
        dispatch(loadingIndicator(false, types.LOAD_ORG));
      });
  };
}

export function fetchOrgList() {
  return (dispatch) => {
    dispatch(loadingIndicator(true, types.LOAD_ORG_LIST));
    mokaRequest('/api/outer/ats-jc/headhunter/org-list', {
      actionName: i18n.t`获取公司列表`,
      interceptOnError: true,
    })
      .get()
      .then((orgList) => {
        dispatch(updateOrgList(orgList));
        dispatch(loadingIndicator(false, types.LOAD_ORG_LIST));
      })
      .catch(() => {
        dispatch(loadingIndicator(false, types.LOAD_ORG_LIST));
      });
  };
}

/**
 *  获取用户是否同意隐私
 */
export function getSecretPolicy() {
  return mokaRequest('/api/outer/ats-common/privacy/agreement/headhunter').post({
    policy: PRIVACY_TYPE.AGREEMENT,
  });
}
/**
 *  设置用户同意隐私否
 */
export function setSecretPolicy(agreement) {
  return () => {
    return mokaRequest('/api/outer/ats-common/privacy/agree/headhunter', {
      actionName: i18n.t`设置同意隐私`,
      interceptOnError: true,
    }).post({
      policy: PRIVACY_TYPE.AGREEMENT,
      agreement,
    });
  };
}

/**
 * 获取候选人二次确认所需要的必填字段
 * @param {string} orgId
 * @param {boolean} isRpo
 */
export function getMandatoryField(orgId, isRpo, jobId) {
  return mokaRequest('/api/outer/ats-jc/application/headhunter/confirm/getMandatoryField').post({
    orgId,
    isRpo,
    jobId,
  });
}

export function getHeadhunterSetting(orgId) {
  return (dispatch) => {
    dispatch(updateHeadhunterSetting({}));
    mokaRequest('/api/outer/ats-candidate/candidate/headhunters/querySetting')
      .post({
        orgId,
      })
      .then((setting) => {
        dispatch(updateHeadhunterSetting(setting));
      });
  };
}

export function getHeadhunterApplyForm(orgId) {
  return (dispatch) => {
    dispatch(updateHeadhunterApplyForm({}));
    mokaRequest('/api/outer/ats-candidate/candidate/headhunters/queryApplyForm')
      .post({
        orgId,
      })
      .then((applyForm) => {
        const applyFormFormat = (form) => {
          const { campusApplyForm, socialApplyForm, rpoCampusApplyForm, rpoSocialApplyForm } = form;
          const format = (item) => {
            let data = {};
            if (item) {
              const { applyForm: applyFormInfo, customBlocks = [], customFields = [] } = item;
              data.applyForm = {
                ...applyFormInfo,
                ...(applyFormInfo.locales && { locales: JSON.parse(applyFormInfo.locales) }),
                ...(applyFormInfo.setting && { setting: JSON.parse(applyFormInfo.setting) }),
              };
              data.customBlocks = customBlocks.map((i) => ({
                ...i,
                ...(i.supplementaryLocales && {
                  supplementaryLocales: JSON.parse(i.supplementaryLocales),
                }),
              }));
              data.customFields = customFields.map((i) => ({
                ...i,
                ...(i.statement && {
                  statement: JSON.parse(i.statement),
                }),
                ...(i.linkage && {
                  linkage: JSON.parse(i.linkage),
                }),
                ...(i.supplementaryLocales && {
                  supplementaryLocales: JSON.parse(i.supplementaryLocales),
                }),
                ...(i.detail && {
                  detail: JSON.parse(i.detail),
                }),
              }));
            }
            return data;
          };

          return {
            ...form,
            ...{
              campusApplyForm: format(campusApplyForm),
              socialApplyForm: format(socialApplyForm),
              rpoCampusApplyForm: format(rpoCampusApplyForm),
              rpoSocialApplyForm: format(rpoSocialApplyForm),
            },
          };
        };
        dispatch(updateHeadhunterApplyForm(applyFormFormat(applyForm)));
      });
  };
}

export function getOverseasNumber(orgId) {
  return (dispatch) => {
    dispatch(updateOverseasNumber({}));
    mokaRequest('/api/outer/ats-apply/website/listCountryCallingCodesWithoutSecret')
      .post({ orgId })
      .then((res) => {
        const countryCallingCodes = unionBy(
          res.countryCallingCodes?.map((item) => ({
            code: item.code.replace('+', ''),
            validRegex: item.validRegex.replaceAll('\\\\', '\\'),
            cnName: item.cnName,
            enName: item.enName,
          })),
          'code'
        );
        dispatch(updateOverseasNumber({ ...res, countryCallingCodes }));
      });
  };
}
